<template>
  <div>
    <QuillEditor
      v-model:content="content"
      :options="editorOptions"
      contentType="html"
      @update:content="updateContent"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";
import { QuillEditor } from "@vueup/vue-quill";

export default defineComponent({
  components: {
    QuillEditor,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const content = ref(props.modelValue);
    const editorOptions = {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          [
            {
              color: [
                "#000000",
                "#ff0000",
                "#0000ff",
                "#ffff00",
                "#008000",
                "#800080",
              ],
            },
          ],
          ["bold", "italic", "underline"],
          [{ indent: "-1" }, { indent: "+1" }],
          [{ align: [] }],
          [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        ],
      },
    };

    watch(
      () => props.modelValue,
      (newValue) => {
        content.value = newValue;
      }
    );

    watch(content, (newValue) => {
      console.log("Content updated:", newValue);
      emit("update:content", newValue);
    });

    const updateContent = (newValue: string) => {
      content.value = newValue;
    };

    return {
      content,
      editorOptions,
      updateContent,
    };
  },
});
</script>

<style scoped>
/* 必要に応じてカスタムスタイルを追加 */
</style>
